import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { CompanyPageLayout } from 'client-portal/components/PageLayout'
import { Container, Box } from 'components/Layout'
import { Events } from './Events'

interface RouterProps {
  companyId: string
}

type Props = RouteComponentProps<RouterProps>

export const EventSession: React.FC<Props> = ({ match }) => {
  const { companyId } = match.params
  return (
    <CompanyPageLayout>
      <Container>
        <Events filter={{ companyId, status: 'open' }} title="Open Company Events" />
        <Box mt="2rem" mb="2rem">
          <Events filter={{ companyId, status: 'closed' }} title="Closed Company Events" />
        </Box>
      </Container>
    </CompanyPageLayout>
  )
}
